<script setup>
const props = defineProps({
  isShowed: {
    type: Boolean,
    default: true
  }
})
const isShowed = ref(props.isShowed)
const list = [
  {
    title: '観測水位',
    type: 'circle',
    contents: [
      { text: '計画高', rank: '5' },
      { text: '氾濫危険', rank: '4' },
      { text: '避難判断', rank: '3' },
      { text: '氾濫注意', rank: '2' }
    ]
  },
  {
    title: '指定河川洪水予報',
    type: 'square',
    contents: [
      { text: '氾濫発生', rank: '5' },
      { text: '氾濫危険', rank: '4' },
      { text: '氾濫警戒', rank: '3' },
      { text: '氾濫注意', rank: '2' }
    ]
  }
]

const onClickLegend = () => {
  isShowed.value = !isShowed.value
}

onMounted(() => {
  if (window.innerWidth <= 830) {
    isShowed.value = false
  }
})
</script>

<template>
  <div
    class="riverLegend"
    :class="{ 'is-showed': isShowed }"
  >
    <button @click="onClickLegend()">
      <span :class="isShowed ? 'right-arrow' : 'left-arrow'">
        凡例
      </span>
    </button>
    <div class="content">
      <div
        v-for="content in list"
        :key="content.title"
        class="block"
        :data-type="content.type"
      >
        <p>{{ content.title }}</p>
        <ul>
          <li
            v-for="item in content.contents"
            :key="item.rank + '-' + item.text"
            :data-rank="item.rank"
          >
            {{ item.text }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.riverLegend {
  position: absolute;
  bottom: 10px;
  left: calc(100% - 45px);
  display: flex;
  align-items: flex-end;
  transition: left .2s ease-in-out;
  z-index: 2;
  pointer-events: none;
  &.is-showed {
    left: calc(100% - 171px);
  }
  button {
    padding: 5px 3px 5px 4px;
    border-top-left-radius: 100vmax;
    border-bottom-left-radius: 100vmax;
    background-color: rgb(0 0 0 / .75);
    pointer-events: all;
    span {
      padding-left: 14px;
      background-repeat: no-repeat;
      background-position: left center;
      background-size: contain;
      color: #FFF;
      font-size: 12px;
      font-weight: 600;
      line-height: 1em;
      white-space: nowrap;
    }
    .right-arrow {
      background-image: url('https://gvs.weathernews.jp/onebox/img/icon/icon_arrow.svg');
    }
    .left-arrow {
      background-image: url('https://gvs.weathernews.jp/onebox/img/icon/icon_left_arrow.svg');
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 8px 10px;
    border-radius: 6px 6px 6px 0;
    background-color: rgb(0 0 0 / .75);
    .block {
      display: flex;
      flex-direction: column;
      gap: 8px;
      p {
        color: #FFF;
        font-size: 12px;
        font-weight: 600;
        line-height: 1em;
        white-space: nowrap;
      }
      ul {
        display: flex;
        flex-direction: column;
        gap: 2px;
      }
      li {
        position: relative;
        padding-left: 20px;
        color: #FFF;
        font-size: 12px;
        line-height: 15px;
        white-space: nowrap;
        &::before {
          position: absolute;
          top: 0;
          left: 0;
          width: 15px;
          height: 15px;
          border: solid 1px #FFF;
          content: '';
        }
        &[data-rank='5']::before {
          background-color: #0C000C;
        }
        &[data-rank='4']::before {
          background-color: #AB01AA;
        }
        &[data-rank='3']::before {
          background-color: #FF2900;
        }
        &[data-rank='2']::before {
          background-color: #F2E700;
        }
        &:is([data-type='circle'] *)::before {
          border-radius: 50%;
        }
      }
    }
  }
  @media (any-hover: hover) {
    button {
      cursor: pointer;
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .8;
      }
    }
  }
}
@media (min-width: 830px) {
  .riverLegend {
    left: calc(100% - 51px);
    &.is-showed {
      left: calc(100% - 193px);
    }
    button {
      span {
        padding-left: 16px;
        font-size: 14px;
      }
    }
    .content {
      .block {
        p {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
